module.exports = __webpack_public_path__ + "img/Shandong-power.d8a13e70.png";